import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './agencies/Home';
import Travel from './agencies/Travel';
import Security from './agencies/Security';
import Cleaning from './agencies/Cleaning';
import RealEstate from './agencies/RealEstate';
import OurApps from './pages/OurApps';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Construction from './agencies/Construction';
import AboutUs from './pages/AboutUs';
import Jobs from './pages/Jobs';
import EmployeePortal from './pages/EmployeePortal';
import ClientPortal from './pages/ClientPortal';

function App() {
  useEffect(() => {
    const preventZoom = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    const preventGesture = (e) => {
      e.preventDefault();
    };

    window.addEventListener('wheel', preventZoom, { passive: false });
    window.addEventListener('gesturestart', preventGesture);

    return () => {
      window.removeEventListener('wheel', preventZoom);
      window.removeEventListener('gesturestart', preventGesture);
    };
  }, []);

  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/security" element={<Security />} />
            <Route path="/cleaning" element={<Cleaning />} />
            <Route path="/realestate" element={<RealEstate />} />
            <Route path="/construction" element={<Construction />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/apps" element={<OurApps />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/clientportal" element={<ClientPortal />} />
            <Route path="/employeeportal" element={<EmployeePortal />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
